<div class="custom-textbox">
    <input 
      type="text" 
      [value]="getSelectedText()" 
      readonly 
      (click)="toggleDropdown()" 
    />

    <div class="dropdown-body" *ngIf="dropdownOpen">
      <div *ngFor="let item of items"> 
        <label>
          <input 
            type="checkbox" 
            [checked]="isChecked(item)" 
            (change)="onCheckboxChange(item, $event)" 
          />
          {{ item }}
        </label>
      </div>
    </div>
</div>
